import { render, staticRenderFns } from "./AboutCaseStudy.vue?vue&type=template&id=74609208&scoped=true&"
import script from "./AboutCaseStudy.vue?vue&type=script&lang=js&"
export * from "./AboutCaseStudy.vue?vue&type=script&lang=js&"
import style0 from "./AboutCaseStudy.vue?vue&type=style&index=0&id=74609208&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74609208",
  null
  
)

export default component.exports